import { render, staticRenderFns } from "./savedSalaryStructure.vue?vue&type=template&id=6e3dae91&scoped=true"
import script from "./savedSalaryStructure.vue?vue&type=script&lang=js"
export * from "./savedSalaryStructure.vue?vue&type=script&lang=js"
import style0 from "./savedSalaryStructure.vue?vue&type=style&index=0&id=6e3dae91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3dae91",
  null
  
)

export default component.exports